import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import {
  ButtonComponent,
  IconComponent,
  ToastComponent,
} from '@sarasanalytics-com/design-system';
import { IUserInfo } from 'src/app/interfaces/state-interface';
import { IToast } from 'src/app/interfaces/toast-interface';
import { AppService } from 'src/app/services/app.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import {
  IMessageView,
  MessageViewComponent,
  MessageViewEvent,
} from 'src/app/shared/components/message-view/message-view.component';
import { password } from 'src/app/static/form';
import {
  defaultMessageViewFailure,
  forgotPasswordSuccess,
  linkExpiry,
  workEmailNotVerified,
} from 'src/app/static/message-view';
import { samePasswordValidator } from 'src/app/validators/validators';
import { ProductDetailService } from 'src/app/services/product/productdetails.service';
import { Products} from 'src/app/interfaces/state-interface';
@Component({
  selector: 'app-reset',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    ReactiveFormsModule,
    FormlyModule,
    FormsModule,
    ButtonComponent,
    ToastComponent,
    MessageViewComponent,
  ],
  templateUrl: './reset.component.html',
  styleUrl: './reset.component.scss',
})
export class ResetComponent {
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private appService: AppService = inject(AppService);
  private signupService: SignupService = inject(SignupService);
  private productService: ProductDetailService = inject(ProductDetailService);

  messageView: IMessageView | null; //=resetSuccess('emma.taylor@brandxyz.com');
  showToast: boolean = false;
  toast: IToast | null;
  email: string;

  form: FormGroup;
  model: any = {};
  fields: FormlyFieldConfig[] = [];

  code: string;
  userId: string;
  isLoading: boolean = false;
  showInitialLoader: boolean = true;
  product_logo: string = '';
  product: Products;

  ngOnInit() {
    this.form = new FormGroup({});
    setTimeout(() => {
      this.userId = this.route.snapshot.queryParamMap.get('id') || '';

      this.code = this.route.snapshot.queryParamMap.get('code') || '';
      this.product_logo = this.productService.getProductLogo(this.product);
      this.email = this.appService.sanitizeEmailFromParams(this.route.snapshot.queryParamMap.get('email') || '');
      this.checkLinkExpiry(this.userId, this.code);
    }, 0);
  }

  checkLinkExpiry(userId: string, code: string){
    this.showInitialLoader = true;
    try{
      this.signupService.checkLinkExpiry(userId, code).subscribe({
        next: (response)=>{
          this.showInitialLoader = false;
          if (response.success && response.data === "VALID_LINK") {
            this.generateForm();
          }else{
            this.showExpiryMessageView(response.errors);
          }
        },
        error: (err)=>{
          this.showInitialLoader = false;
          console.log(err);
          this.showExpiryMessageView(err);
        }
      })
    }catch(e){
      console.log(e);
    }
  }

  showExpiryMessageView(errors: any){
    if(errors?.code === 'E0004'){
      this.messageView = linkExpiry();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      this.signupService
        .setPassword(this.code || '', this.userId || '', this.model.password)
        .subscribe({
          next: (value) => {
            this.isLoading = false;
            if (value.success) {
              this.router.navigate(['/login']);
            } else {
              this.toast = value?.error?.message || failureToast;
            }
          },
          error: (err) => {
            this.isLoading = false;
            this.toast = err?.error?.message || failureToast;
          },
        });
    }else{
      this.form.markAllAsTouched();
    }
  }

  modelChangeHandler(evt: any) {
    this.form.get('reenter-password')?.updateValueAndValidity();
  }
  generateForm() {
    this.fields = [
      {
        key: 'password',
        type: 'sa-input',
        className: 'col-12',
        props: password('Must contain minimum of 8 characters', {
          placeholder: 'New password',
          validators: [Validators.minLength(8)]
        }),
      },
      {
        key: 'reenter-password',
        type: 'sa-input',
        className: 'col-12',
        props: password('', {
          placeholder: 'Re-enter New Password',
          validators: [samePasswordValidator('password'), Validators.minLength(8)],
        }),
      },
    ];

    this.form.statusChanges.subscribe((state) => {
      // console.log('on form change', this.model);
    });
  }

  onMessageViewEvent(evt: any) {
    switch (evt.type) {
      case MessageViewEvent.BUTTON:
        this.router.navigate(['/login']);
        break;
      case MessageViewEvent.REFRESH:
        break;
      case MessageViewEvent.RESEND:
        // this.sendVerificationEmail();
        this.signupService.forgotPassword(this.email).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageView = forgotPasswordSuccess(this.email);
            } else {
              if(response.code === "E0002"){
                this.messageView = workEmailNotVerified(this.email);
              }else{
                this.messageView = defaultMessageViewFailure
              }
            }
          },
          error: (err) => {},
        });
        break;
    }
  }

  
}
const failureToast: IToast = {
  status: 'failure',
  subHeading: 'Something went wrong, retry after some time.',
};
